div[data-test-id='userlike-container'] {
  position: relative;
  z-index: 1000; // same as in lilu-header. Because this element appears later, chat is on top
}

.diva-pseudo-fullscreen div[data-test-id='userlike-container'] {
  z-index: 1000001;
}
